// libs
import styled from 'styled-components'
// components
import { Scrollbar as ScrollbarOrigin } from 'components/UI'
import { BottomPaper as BottomPaperOrigin } from './settings'
// themes
import { colors } from 'themes'
// utils
import { darken } from 'polished'

const AddButton = styled('div')`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    margin-top: 10px;
    white-space: nowrap;
    width: min-content;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`

const BottomPaper = styled(BottomPaperOrigin)`
  && {
    margin: 0;
    width: 600px;

    > div:first-child {
      margin-right: 16px;
    }
  }
`

const Form = styled('form')`
  height: calc(100% - 120px);
`

const TitleWrapper = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 16px 0;

  & > div:last-child {
    min-width: 121px;
    margin-left: 16px;
  }
`

const Title = styled('div')`
  color: ${colors.gray400};
  font-size: 14px;
`

const Scrollbar = styled(ScrollbarOrigin)`
  padding: 16px 24px 0 16px;

  > div {
    margin-bottom: 16px;
  }

  > svg {
    position: absolute;
    right: 20px;
    top: 8px;
    z-index: 1;
  }
`

export { AddButton, BottomPaper, Form, Title, TitleWrapper, Scrollbar }
